import { type ErrorsHandbook, HttpService, BaseService } from '@/6_shared/api'
import { getMilliseconds } from '@/6_shared/lib'
import type { BaseSearchFilters } from '@/6_shared/model'
import type { HomeCompilationResponse, HomeFreeEventsQuery, HomeFreeEventsResponse } from '../model'
import { homeErrorsHandbook } from './error/HomeErrorsHandbook.ts'

class HomeService extends BaseService {
  private readonly _endpoint: string = 'homepage'

  constructor(http: typeof HttpService, errorsHandbook: ErrorsHandbook) {
    super(http, errorsHandbook)
  }

  public getCompilations(query: BaseSearchFilters) {
    return this._http.get<HomeCompilationResponse>([this._endpoint, 'compilations'].join('/'), {
      needCancelOnRouteChange: true,
      cacheConfig: {
        lifeTime: getMilliseconds.inHours(1)
      },
      query,
      queryAsString: true
    })
  }

  public getFreeEvents(query: HomeFreeEventsQuery) {
    return this._http.get<HomeFreeEventsResponse>([this._endpoint, 'list'].join('/'), {
      needCancelOnRouteChange: true,
      query,
      queryAsString: true
    })
  }
}

const homeService = new HomeService(HttpService, homeErrorsHandbook)

export { homeService }
